import { render } from "./App.vue?vue&type=template&id=618b0702"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=618b0702&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__